import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { finalize, take, switchMap } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from '../header/header.component';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { LiveServiceHttpService } from '../../shared/services/live-service-http.service';
import { WsLiveServiceService } from '../../shared/services/ws-live-service.service';
import { ToastService } from '../../shared/services/toast-service.service';
import { SessionResponseModel } from '../../shared/models/sessionResponseModel';
import { LIVE_FEED_TYPE_TYPE } from '../../shared/configs/live-feed-type.config';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-activate-feed',
  standalone: true,
  imports: [CommonModule, HeaderComponent, MatProgressSpinnerModule, FormsModule, OtpInputComponent],
  templateUrl: './activate-feed.component.html',
  styleUrl: './activate-feed.component.scss'
})
export class ActivateFeedComponent {

  public loading = false;
  public otp = '';

  constructor(
    private liveServiceHttpService: LiveServiceHttpService,
    private wsLiveServiceService: WsLiveServiceService,
    private router: Router,
    private toastService: ToastService
  ) {
  }

  public submit() {
    this.loading = true;
    // Activate OTP
    this.liveServiceHttpService.activateOTP({ otp: this.otp })
      .pipe(
        take(1),
        switchMap(res => this.activateFeed(res))
      )
      .subscribe({
        next: res => {
          this.navigateActiveFeed(res.liveStreamType);
          this.toastService.displaySuccess('Live stream connected, navigating to view.');
        },
        error: err => {
          this.toastService.displayError('Failed to connect to live stream.');
          this.router.navigate(['/invalid-otp']);
        }
      });

  }

  private activateFeed(session: SessionResponseModel): Observable<{ liveStreamType: string }> {
    return this.wsLiveServiceService.setNewConnection(session);
  }

  private navigateActiveFeed(liveFeedType: string) {
    switch (liveFeedType) {
      case LIVE_FEED_TYPE_TYPE.THEATRE_CASES:
        this.router.navigate(['/hospital-theatre-cases']);
        break;
      default:
        this.router.navigate(['feed-type-not-supported']);
        break;
    }
  }
}
